ko.bindingHandlers.addressAutocomplete = {
    init: function (element, valueAccessor, allBindingsAccessor) {
        var value = valueAccessor();
        var allBindings = allBindingsAccessor();

        function attach(el) {
            if (value.target) {
                var target = value.target;
                var types = value.types ? value.types : 'geocode';
            }

            if (value.element) {
                el = document.getElementById(value.element)
            }

            //@FIXME forzato autocompletamento di tipo geocode
            var options = {
                types: ['geocode'],
                componentRestrictions: {country: 'it'}
            };
            ko.utils.extend(options, allBindings.autocompleteOptions);

            var autocomplete = new google.maps.places.Autocomplete(el, options);
            google.maps.event.addListener(autocomplete, 'place_changed', function () {
                var place = autocomplete.getPlace();
                if (!place || !place.geometry) {
                    return;
                }
                target(place);
                //@TODO trovare soluzioen piu elegante e implementare ovunque
                if (value.event) {
                    value.event();
                }
            });
        }

        function mapsReady() {
            return typeof google !== 'undefined' && google &&
                google.maps && google.maps.places && google.maps.places.Autocomplete;
        }

        if (mapsReady()) {
            attach(element);
            return;
        }

        // Dove Google Maps si carica a richiesta (tgMaps in lib/restfool.js) il campo
        // nasce come input di testo normale: Maps parte appena il visitatore ci si
        // avvicina, e l'autocompletamento si aggancia quando arriva.
        if (window.tgMaps) {
            tgMaps.onReady(function () {
                if (!mapsReady()) {
                    return;
                }
                try {
                    attach(element);
                } catch (e) {
                    if (window.console && console.warn) {
                        console.warn('addressAutocomplete: aggancio a Google Maps fallito', e);
                    }
                }
            });

            var input = value.element ? (document.getElementById(value.element) || element) : element;
            var warm = function () {
                tgMaps.load();
            };
            var events = ['focus', 'mouseenter', 'touchstart'];
            for (var i = 0; i < events.length; i++) {
                input.addEventListener(events[i], warm);
            }
            if (document.activeElement === input) {
                warm();
            }
            return;
        }

        // La guardia precedente controllava solo l'esistenza di "google", che pero'
        // e' definito anche dal solo script di login Google (google.accounts): bastava
        // che maps.googleapis.com non fosse ancora caricato — perche' bloccato dal CMP
        // in attesa del consenso, per un adblock o per un problema di rete — e la riga
        // sotto lanciava un TypeError. Knockout lo propaga verso l'alto e fa fallire
        // l'intero albero di binding che contiene il campo, quindi cadeva tutta la
        // modale di ricerca, non solo l'autocompletamento.
        //
        // Ora l'assenza di Maps degrada il campo a input di testo normale, e se Maps
        // arriva piu' tardi l'autocompletamento si aggancia da solo.
        var waited = 0;
        var poll = setInterval(function () {
            waited += 400;
            if (mapsReady()) {
                clearInterval(poll);
                try {
                    attach(element);
                } catch (e) {
                    if (window.console && console.warn) {
                        console.warn('addressAutocomplete: aggancio a Google Maps fallito', e);
                    }
                }
            } else if (waited >= 20000) {
                clearInterval(poll);
                if (window.console && console.warn) {
                    console.warn('addressAutocomplete: Google Maps non disponibile, ' +
                        'il campo resta un input di testo semplice.');
                }
            }
        }, 400);
    },
    update: function (element, valueAccessor, allBindingsAccessor) {
        ko.bindingHandlers.value.update(element, valueAccessor);
    }
};
